import axios from "axios"
import { toast } from "react-toastify";
export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL


export const CreateDocument=async(formData)=>{
    console.log(formData);
    try{
        const responce = await axios.post(`${BACKEND_URL}/api/document`,formData);
        if(responce==="OK"){
            toast.success("Added")
        }
        return responce
    }catch(error){
        const message = (error.response && error.response.data && error.response.data.message
        ) || error.message || error.toString()
        toast.error(message)
    }
}


export const GetDocument =async()=>{
    try{
        const responce = await axios.get(`${BACKEND_URL}/api/document`);
        return responce;
    }catch(error){
        const message = (error.response && error.response.data && error.response.data.message
        ) || error.message || error.toString()
        toast.error(message)
    }
}


export const GetByIdDocument =async(amdno)=>{
    try{
        const responce = await axios.get(`${BACKEND_URL}/api/document/${amdno}`);
        return responce.data;
    }catch(error){
        const message = (error.response && error.response.data && error.response.data.message
        ) || error.message || error.toString()
        toast.error(message)
    }
}


export const updateDocument = async(formData)=>{
    try{
        const responce = await axios.patch(`${BACKEND_URL}/api/document`,formData)
        return responce.data


    }catch(error){
        const message = (error.response && error.response.data && error.response.data.message
        ) || error.message || error.toString()
        toast.error(message)
    }
}


export const CheckAmdNo = async(formData)=>{
    try{
        const responce = await axios.post(`${BACKEND_URL}/api/document/check/${formData}`)
        return responce.data


    }catch(error){
        const message = (error.response && error.response.data && error.response.data.message
        ) || error.message || error.toString()
        toast.error(message)
    }
}